import {Component} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AuthState} from '../../../../../state/auth/auth.state';
import {Observable} from 'rxjs';
import {SystemUser} from '../../../../../models/system-user.model';
import {AuthActions} from '../../../../../state/auth/auth.actions';
import {AuthService} from '../../../../../services/auth.service';
import {PasswordChangeActions} from '../../../../../state/password-change/password-change.actions';

@Component({
    selector: 'app-navbar-user-menu',
    templateUrl: './navbar-user-menu.component.html',
    styleUrls: ['./navbar-user-menu.component.less']
})
export class NavbarUserMenuComponent {
    @Select(AuthState.currentUser) user$: Observable<SystemUser>;

    constructor(private authService: AuthService, private store: Store) {
    }

    logout() {
        this.store.dispatch(new AuthActions.LogoutRequest());
    }

    changePassword() {
        this.store.dispatch(new PasswordChangeActions.OpenModal());
    }

}
